module.exports = __webpack_public_path__ + "static/media/cert_78.30a41eb9.jpg";